import React from "react";
import * as S from "../../css/Barcode.styles";

// NOTE Vass 화물추적 정보 Blank창으로 띄워서 표시
const TrackingBlank = ({ trackingList }) => {
  // 2열 테이블 표시
  const InfoRow = ({ title, value }) => (
    <tr>
      <S.TableData colSpan={2}>{title}</S.TableData>
      <S.TableData colSpan={2}>{value || ""}</S.TableData>
    </tr>
  );
  // 4열 테이블 표시
  const InfoDoubleRow = ({ title1, value1, title2, value2 }) => (
    <tr>
      <S.TableData>{title1}</S.TableData>
      <S.TableData>{value1 || ""}</S.TableData>
      <S.TableData>{title2}</S.TableData>
      <S.TableData>{value2 || ""}</S.TableData>
    </tr>
  );
  // 일부 데이터 *로 표기
  const maskValue = (value, maskLength = 1) =>
    value
      ? value.slice(0, maskLength) +
        "*".repeat(Math.max(0, Math.min(3, value.length - maskLength)))
      : "";

  const headers = ["날짜", "시간", "사업장", "배송상태"];

  return (
    <>
      <S.ListInfoContainer>
        <nav>
          <h5>물품정보</h5>
        </nav>
        <S.Table>
          <tbody>
            <InfoRow
              title="운송장 번호"
              value={trackingList.relation_list?.[0]?.iv_no_relation}
            />
            <InfoRow
              title="상품명"
              value={maskValue(trackingList.goods_nm, 2)}
            />
            <InfoRow
              title="보내시는 분"
              value={maskValue(trackingList.cust_nm)}
            />
            <InfoRow
              title="받으시는 분"
              value={maskValue(trackingList.dv_nm)}
            />
            <InfoRow title="주소" value={trackingList.dv_address_jibun} />
            <InfoDoubleRow
              title1="집하일자"
              value1={trackingList.pick_date}
              title2="전송수량"
              value2={trackingList.qa}
            />
            <InfoDoubleRow
              title1="배송지점"
              value1={trackingList.dv_trade_nm}
              title2="집하지점"
              value2={trackingList.pick_trade_nm}
            />
          </tbody>
        </S.Table>
        <hr />
        <nav>
          <h5>배송정보</h5>
          <S.Table>
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <S.TableHeader key={index}>{header}</S.TableHeader>
                ))}
              </tr>
            </thead>
            <tbody>
              {trackingList.trace_list?.map((item, index) => (
                <tr key={index}>
                  <S.TableData>{item.scan_date || ""}</S.TableData>
                  <S.TableData>{item.scan_time || ""}</S.TableData>
                  <S.TableData>{item.trade_nm || ""}</S.TableData>
                  <S.TableData>{item.state_nm || ""}</S.TableData>
                </tr>
              )) || (
                <tr>
                  <td colSpan={headers.length}>
                    배송정보 조회내역이 존재하지 않습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </S.Table>
        </nav>
        <hr />
        <nav>
          <h5>배송 영업소 정보</h5>
        </nav>
        <S.Table>
          <tbody>
            <InfoRow
              title="최종 처리시간"
              value={`${
                trackingList.trace_list?.[trackingList.trace_list.length - 1]
                  ?.scan_date || ""
              } ${
                trackingList.trace_list?.[trackingList.trace_list.length - 1]
                  ?.scan_time || ""
              } ${
                trackingList.trace_list?.[trackingList.trace_list.length - 1]
                  ?.state_nm || ""
              }`}
            />
            <InfoRow
              title="배송 예정시간"
              value={
                trackingList.trace_list?.[trackingList.trace_list.length - 2]
                  ?.dv_time_nm
              }
            />
            <InfoRow
              title="최종 처리 사업장"
              value={
                trackingList.trace_list?.[trackingList.trace_list.length - 1]
                  ?.trade_nm
              }
            />
            <InfoRow title="연락처" value={trackingList.dv_tradesub_tel} />
            <InfoRow title="영업사원" value={trackingList.dv_tradesub_nm} />
          </tbody>
        </S.Table>
      </S.ListInfoContainer>
    </>
  );
};

export default TrackingBlank;
